import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import styles from "./ViewPotentialClient.module.css";

function ViewPotentialClient() {
  const params = useParams();

  const [data] = useFetch(
    `https://artmadein-dashboard-backend.onrender.com/api/v1/client/getsinglepotentialclient/${params.id}`
    // `http://localhost:5000/api/v1/client/getsinglepotentialclient/${params.id}`
  );

  return (
    <>
      <div className={styles.container}>
        <div className={styles.box}>
          <table className={styles.table}>
            <thead>
              <tr className={styles.tr}>
                <th className={styles.th}>Company Name</th>
                <td className={styles.td}>{data.companyName}</td>
              </tr>
              <tr className={styles.tr}>
                <th className={styles.th}>Country</th>
                <td className={styles.td}>{data.country}</td>
              </tr>
              <tr className={styles.tr}>
                <th className={styles.th}>Business Category</th>
                <td className={styles.td}>{data.businessCategory}</td>
              </tr>
              <tr className={styles.tr}>
                <th className={styles.th}>Email</th>
                <td className={styles.td}>{data.email}</td>
              </tr>
              <tr className={styles.tr}>
                <th className={styles.th}>Instagram Id</th>
                <td className={styles.td}>
                  <a href={data.instagramId} target="_blank" rel="noreferrer">
                    {data.instagramId}
                  </a>
                </td>
              </tr>
              <tr className={styles.tr}>
                <th className={styles.th}>Facebook Id</th>
                <td className={styles.td}>
                  <a href={data.facebookId} target="_blank" rel="noreferrer">
                    {data.facebookId}
                  </a>
                </td>
              </tr>
              <tr className={styles.tr}>
                <th className={styles.th}>Linkedin Id</th>
                <td className={styles.td}>
                  <a href={data.linkedinId} target="_blank" rel="noreferrer">
                    {data.linkedinId}
                  </a>
                </td>
              </tr>
              <tr className={styles.tr}>
                <th className={styles.th}>Contact Number</th>
                <td className={styles.td}>{data.contactNumber}</td>
              </tr>
              <tr className={styles.tr}>
                <th className={styles.th}>Contact Person</th>
                <td className={styles.td}>{data.contactPerson}</td>
              </tr>
              <tr className={styles.tr}>
                <th className={styles.th}>Address</th>
                <td className={styles.td}>{data.address}</td>
              </tr>
              <tr className={styles.tr}>
                <th className={styles.th}>Created By</th>
                <td className={styles.td}>{data.createdBy?.userName}</td>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </>
  );
}

export default ViewPotentialClient;
